import { useTheme as _ut } from "emotion-theming";
export { theme } from "./theme";
export { ThemeProvider } from "emotion-theming";
export { default as GlobalStyles } from "./GlobalStyles";
export var useTheme = function useTheme() {
  return _ut();
};